/** An element from index.html; a missing one is a bug in the page, not a runtime case. */
export function el<T extends HTMLElement = HTMLElement>(id: string): T {
  return document.getElementById(id) as T;
}
